(() => {
  const shopRoot = window.Shopify?.routes?.root || "/";

  const isCheckoutTarget = (el) => {
    if (!el) return false;
    if (el.matches('a[href^="/checkout"], a[href*="/checkout"]')) return true;
    if (el.matches('button[name="checkout"], input[name="checkout"]')) return true;
    if (el.matches("[data-checkout], [data-cart-checkout]")) return true;
    return false;
  };

  const countUploadKitFiles = (properties) => {
    if (!properties || typeof properties !== "object") return 0;

    let count = 0;

    for (const [k, v] of Object.entries(properties)) {
      if (!v) continue;

      const key = String(k).toLowerCase();
      const value = String(v).toLowerCase();

      const looksLikeUploadKit = value.includes("uploadkit.app");
      const looksLikeFileKey =
        key.includes("photo") ||
        key.includes("archivo cargado") ||
        key.includes("uploaded") ||
        key.includes("file");

      if (looksLikeUploadKit && looksLikeFileKey) {
        count += 1;
      }
    }

    return count;
  };
    const syncUploadKitQuantity = (form) => {
    const uploadCount = [
      ...form.querySelectorAll('[name^="properties["]')
    ].filter((field) => {
      const key = String(field.name).toLowerCase();

      return (
        key.includes("archivo cargado") ||
        key.includes("uploaded") ||
        key.includes("photo") ||
        key.includes("file")
      );
    }).length;

    if (uploadCount < 1) return;

    let quantityInput = form.querySelector('input[name="quantity"]');

    if (!quantityInput) {
      quantityInput = document.createElement("input");
      quantityInput.type = "hidden";
      quantityInput.name = "quantity";
      quantityInput.dataset.uploadkitAutoQuantity = "true";
      form.appendChild(quantityInput);
    }

    quantityInput.value = String(uploadCount);
  };

  document.addEventListener(
    "click",
    (event) => {
      const button = event.target?.closest?.(
        'form.uploadkit-form button[type="submit"]'
      );

      if (!button) return;

      syncUploadKitQuantity(button.closest("form"));
    },
    true
  );

  document.addEventListener(
    "submit",
    (event) => {
      const form = event.target;

      if (!form?.matches?.("form.uploadkit-form")) return;

      syncUploadKitQuantity(form);
    },
    true
  );

  setupUploadForms();

  new MutationObserver(setupUploadForms).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  const getCart = async () => {
    const response = await fetch(`${shopRoot}cart.js`, {
      headers: {
        Accept: "application/json",
      },
      credentials: "same-origin",
    });

    if (!response.ok) {
      throw new Error("Failed to load cart");
    }

    return response.json();
  };

const getItemFingerprint = (item) => {
  const visibleProperties = Object.entries(item.properties || {})
    .filter(([key, value]) => {
      return value && !String(key).startsWith("_");
    })
    .map(([key, value]) => [String(key), String(value)])
    .sort(([keyA], [keyB]) => keyA.localeCompare(keyB));

  return JSON.stringify([
    item.variant_id,
    item.selling_plan_allocation?.selling_plan?.id || null,
    visibleProperties,
  ]);
};

const getRequiredUpdates = (cart) => {
  const updates = {};
  const groups = new Map();

  for (const item of cart?.items || []) {
    const uploadCount = countUploadKitFiles(item.properties);
    if (uploadCount === 0) continue;

    const fingerprint = getItemFingerprint(item);

    if (!groups.has(fingerprint)) {
      groups.set(fingerprint, []);
    }

    groups.get(fingerprint).push(item);
  }

  for (const items of groups.values()) {
    const firstItem = items[0];

    const totalQuantity = items.reduce(
      (total, item) => total + item.quantity,
      0
    );

    const uploadCount = Math.max(
      ...items.map((item) => countUploadKitFiles(item.properties))
    );

    // Conserva las copias pedidas, pero nunca permite menos
    // copias que fotos subidas.
    const requiredQuantity = Math.max(totalQuantity, uploadCount);

    if (firstItem.quantity !== requiredQuantity) {
      updates[firstItem.key] = requiredQuantity;
    }

    // Elimina las líneas duplicadas con las mismas fotos.
    for (const duplicate of items.slice(1)) {
      updates[duplicate.key] = 0;
    }
  }

  return updates;
};

  const updateCart = async (updates) => {
    if (!Object.keys(updates).length) return;

    const response = await fetch(`${shopRoot}cart/update.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify({ updates }),
    });

    if (!response.ok) {
      throw new Error("Failed to update cart");
    }

    return response.json();
  };

  let busy = false;

  const handleCheckout = async (event, control) => {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation?.();

    if (busy) return;
    busy = true;

    control?.setAttribute("aria-busy", "true");

    if (control && "disabled" in control) {
      control.disabled = true;
    }

    try {
      const cart = await getCart();
      const updates = getRequiredUpdates(cart);

      await updateCart(updates);

      // El carrito ya tiene la cantidad correcta.
      window.location.assign(`${shopRoot}checkout`);
    } catch (error) {
      console.warn("[UploadKit Guard] checkout error:", error);

      alert(
        "No hemos podido ajustar automáticamente las copias. Actualiza la cesta y vuelve a intentarlo."
      );

      busy = false;
      control?.removeAttribute("aria-busy");

      if (control && "disabled" in control) {
        control.disabled = false;
      }
    }
  };

  document.addEventListener(
    "click",
    (event) => {
      const target = event.target?.closest?.(
        'a, button, input, [role="button"], [data-checkout], [data-cart-checkout]'
      );

      if (!isCheckoutTarget(target)) return;

      handleCheckout(event, target);
    },
    true
  );

  document.addEventListener(
    "submit",
    (event) => {
      const form = event.target;
      if (!form) return;

      const submitter = event.submitter;
      const isCheckoutForm =
        isCheckoutTarget(submitter) ||
        form.matches('form[action^="/checkout"], form[action*="/checkout"]') ||
        form.querySelector('button[name="checkout"], input[name="checkout"]');

      if (!isCheckoutForm) return;

      handleCheckout(event, submitter);
    },
    true
  );
})();